import Stub from './Stub';

export default Stub;
